export class MPAPolicyGroupCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "LogicalOperator",
            "format": ""
        },
        {
            "name": "operands",
            "baseName": "operands",
            "type": "Array<MPAPolicyExpression>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAPolicyGroupCondition.attributeTypeMap;
    }
    constructor() {
    }
}
